import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const BASE_CONTACT = 'https://api.hataoo.in/api/contact/message';
const BASE_REPORT  = 'https://api.hataoo.in/api/contact/report';

const UnreadNotification = () => {
    const navigate = useNavigate();

    const checkUnreadData = async () => {
        if (sessionStorage.getItem('contactUnreadNotificationShown') === 'true') return;

        // Set flag immediately to prevent any parallel/re-render double calls
        sessionStorage.setItem('contactUnreadNotificationShown', 'true');

        try {
            const [contactRes, reportRes] = await Promise.all([
                axios.get(`${BASE_CONTACT}/unread-count`),
                axios.get(`${BASE_REPORT}/unread-count`),
            ]);

            const { count = 0, productCount = 0, influencerCount = 0 } = contactRes.data.data;
            const reportCount = reportRes.data.data?.count ?? 0;

            // ── Toast 1: Contact messages ─────────────────────────────────────
            if (count > 0) {
                const parts = [];
                if (productCount    > 0) parts.push(`${productCount} product`);
                if (influencerCount > 0) parts.push(`${influencerCount} influencer`);

                toast.info(
                    <div
                        className="flex items-center gap-3 cursor-pointer"
                        onClick={() => { navigate('/online-orders/contact-us'); toast.dismiss(); }}
                    >
                        <FontAwesomeIcon icon={faEnvelope} className="text-xl" />
                        <div>
                            <div className="font-semibold">New Contact Messages</div>
                            <div className="text-sm">
                                {count} unread message{count > 1 ? 's' : ''}
                                {parts.length ? ` (${parts.join(' & ')})` : ''}. Click to view.
                            </div>
                        </div>
                    </div>,
                    { position: "top-center", autoClose: 6000, closeOnClick: true, pauseOnHover: true, draggable: true }
                );
            }

            // ── Toast 2: QR Report requests ───────────────────────────────────
            if (reportCount > 0) {
                toast.info(
                    <div
                        className="flex items-center gap-3 cursor-pointer"
                        onClick={() => { navigate('/report-message'); toast.dismiss(); }}
                    >
                        <FontAwesomeIcon icon={faEnvelope} className="text-xl" />
                        <div>
                            <div className="font-semibold">New QR Report Requests</div>
                            <div className="text-sm">
                                {reportCount} unread request{reportCount > 1 ? 's' : ''}. Click to view.
                            </div>
                        </div>
                    </div>,
                    { position: "top-center", autoClose: 6000, closeOnClick: true, pauseOnHover: true, draggable: true }
                );
            }

        } catch (err) {
            console.error('Error checking unread data:', err);
        }
    };

    useEffect(() => {
        checkUnreadData();
    }, []); // ← mount only, never re-runs on route change

    return null;
};

export default UnreadNotification;